import cn from 'classnames/bind'

import { Table, Td, Th, Tr } from 'app/common/ui-components/table'
import Sticky from 'app/common/templates-next/sticky'
import { useCurrencySign, options as co } from 'app/common/components-next/currency'

import { AllSchoolsDto } from '../../../_common/useReportAllSchoolsDto'
import { SummaryDto } from '../../../_common/useReportSummaryDto'
import { Cell } from './Cell'

import styles from './NoGroupTable.scss'

const cx = cn.bind(styles)

type Props = {
  allSchoolsDto: AllSchoolsDto
  summaryDto: SummaryDto
}

export const NoGroupTable = ({ allSchoolsDto, summaryDto }: Props) => {
  const currency = useCurrencySign(co.COMMA_SPACE_BEFORE)

  return (
    <Table wide>
      <thead>
        <Sticky>
          {(ref, _, shadow) => {
            const someProps = {
              borderShadowBottom: shadow,
              bgFilled: true,
            }
            return (
              <Tr header reference={ref}>
                <Th alignLeft borderRight {...someProps}>
                  {'Наименование заведения'}
                </Th>
                <Th alignRight borderRight {...someProps}>
                  {`Индив. справки${currency}`}
                </Th>
                <Th alignRight borderRight {...someProps}>
                  {`Общие справки${currency}`}
                </Th>
                <Th alignRight {...someProps}>
                  {`Всего${currency}`}
                </Th>
              </Tr>
            )
          }}
        </Sticky>
      </thead>
      <tbody>
        {allSchoolsDto.map(({ school_title: title, data: { personal, common, total } }) => (
          <Tr key={title}>
            <Td alignLeft borderRight>
              {title}
            </Td>
            <Td alignRight borderRight>
              <Cell>{personal}</Cell>
            </Td>
            <Td alignRight borderRight>
              <Cell>{common}</Cell>
            </Td>
            <Td alignRight>
              <Cell>{total}</Cell>
            </Td>
          </Tr>
        ))}
      </tbody>
      <tfoot>
        <Sticky stickyBottom>
          {(ref, _, shadow) => {
            const someProps = {
              bgFilled: true,
              highlighted: true,
              bold: true,
            }
            return (
              <Tr reference={ref} className={cx({ shadowTop: shadow })}>
                <Td alignRight borderRight {...someProps}>
                  {'Итого:'}
                </Td>
                <Td alignRight borderRight {...someProps}>
                  <Cell>{summaryDto.totalPersonal}</Cell>
                </Td>
                <Td alignRight borderRight {...someProps}>
                  <Cell>{summaryDto.totalCommon}</Cell>
                </Td>
                <Td alignRight {...someProps}>
                  <Cell>{summaryDto.total}</Cell>
                </Td>
              </Tr>
            )
          }}
        </Sticky>
      </tfoot>
    </Table>
  )
}
